import SidebarLabelDisplay from 'chameleon/legacy/src/components/TeacherOrganize/components/SidebarLabelDisplay';
import {
  getAssignmentStatuses,
  REPORTS_LABEL,
  PROGRESS_DASH_LABEL,
  MASTERY_REPORT_LABEL,
  MASTERY_REPORT_ID,
} from './constants';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import { MY_ASSIGNMENTS, REPORTS } from 'chameleon/src/constants/subjects';
import {
  isResourceVisibilityOverriddenByFF,
  isSubjectHasResource,
} from 'chameleon-src/utility/subjectResources';
const generateStudentNavItemsList = (data) => {
  const {
    isAssignmentsPage,
    masterSubjectWithAssignmentsPagePath,
    addParamsToCurrentLocation = () => {},
    resourceStatus,
    params,
    isDashboardPage,
    showMasteryReport,
    isMasteryReportPage,
    queryParams,
    isStudent,
    afamEp26FullLaunchP1FF,
  } = data;
  const studentAssignmentStatuses = getAssignmentStatuses(false, true);
  const { labels } = useTeacherOrganizeContext({
    masterSubject: params.subject,
  });
  const hasLabels = labels && Object.keys(labels).length > 0;

  const studentsItems = [
    {
      id: MY_ASSIGNMENTS,
      label: 'Assignments',
      iconName: 'resources-assignments',
      children: studentAssignmentStatuses.map(
        ({ id, label, status, others = [], indent }) => ({
          id,
          label,
          to: addParamsToCurrentLocation(
            { status },
            isAssignmentsPage ? null : masterSubjectWithAssignmentsPagePath,
            ['page', 'unit', 'labels', 'type', 'searchTerm'],
          ),
          isActive:
            isAssignmentsPage &&
            (resourceStatus === status ||
              (!queryParams.labels &&
                !!others.length &&
                !others.includes(resourceStatus))),
          indent,
        }),
      ),
      extraChildren: hasLabels && SidebarLabelDisplay,
      isVisible: () =>
        isSubjectHasResource(params.subject, MY_ASSIGNMENTS) ||
        isResourceVisibilityOverriddenByFF(
          params.subject,
          MY_ASSIGNMENTS,
          isStudent,
          {
            afam_ep26_full_launch_p1: afamEp26FullLaunchP1FF,
          },
        ),
    },
    {
      id: REPORTS,
      label: REPORTS_LABEL,
      iconName: 'reports',
      children: [
        {
          id: '31',
          label: PROGRESS_DASH_LABEL,
          to: `/${params.subject}/dashboard`,
          isActive: isDashboardPage,
        },
      ],
      isVisible: () => isSubjectHasResource(params.subject, REPORTS),
    },
  ];

  if (showMasteryReport) {
    studentsItems[1].children.push({
      id: MASTERY_REPORT_ID,
      label: MASTERY_REPORT_LABEL,
      to: `/${params.subject}/reports/csperformance`,
      isActive: isMasteryReportPage,
    });
  }

  return studentsItems;
};

export default generateStudentNavItemsList;
